export default $ => {
  let debounce = require('lodash/debounce')

  const TeamJoin = {
    password: null,
    url: null,
    init() {
      this.password = $('.form_team_join').on('keydown', debounce(this.onkeydown.bind(this),300));
      if (!this.password.length)
        return ;

      this.div = this.password.closest('.eFormBuilderTeamJoin');
      this.results = this.div.find('.team-results');
      this.url = Routing.generate('fe_team_password',{event:this.password.data('event')});

    },onkeydown() {
      $.get(this.url,{password:this.password.val()}).done(function (ret)
      {
         this.results.html(ret)
      }.bind(this))
    }
  }

  TeamJoin.init();
}



// WEBPACK FOOTER //
// ./assets/js/scripts/team-join.js